@if (visible()) {
    <div class="trial-banner" [class.trial-banner--urgent]="urgent()">
        <i class="mdi mdi-timer-sand" aria-hidden="true"></i>
        @if (daysRemaining() === 0) {
            <span>{{ 'trialBanner.expiresToday' | translate }}</span>
        } @else if (daysRemaining() === 1) {
            <span>{{ 'trialBanner.oneDayLeft' | translate }}</span>
        } @else {
            <span>{{ 'trialBanner.daysLeft' | translate: { count: daysRemaining() } }}</span>
        }
    </div>
}
